import { Fragment } from "react";
import dynamic from "next/dynamic";

import { dehydrate, QueryClient, useQuery } from '@tanstack/react-query';
import { getQueryFn, queryKeyManager } from "../../utils/api/queryFunction";
import queryConfig from "../../utils/api/queryConfig";

const SEO = dynamic(() => import("../../components/Shared/SEO"));
const FAD = dynamic(() => import('../../components/Category/FAD/FAD'));
const ProductLayout = dynamic(() => import('../../components/Layout/ProductLayout'));

const FADPage = props => {
	const { token, query } = props;

	const { isLoading, isError, data } = useQuery({
		queryKey: queryKeyManager(["motorcycles", "find-a-dealer"], [token]),
		queryFn: () => getQueryFn("motorcycles/fad", token),
		...queryConfig
	});

	if (isLoading) {
		return <span />
	}

	return (
		<Fragment>
			<SEO seo={data.seo}/>
			<ProductLayout nav={data.nav.header.links} logo={data.nav.header.logos.motorcycles} root="motorcycles" footer={false}>
				<FAD pageData={data} category={data.category} query={ query } />
			</ProductLayout>
		</Fragment>
	);
};

FADPage.getInitialProps = async ({ query, req }) => {
	const queryClient = new QueryClient();
	const { token } = query;

	await queryClient.prefetchQuery({
		queryKey: queryKeyManager(['motorcycles', 'find-a-dealer'], [token]),
		queryFn: () => getQueryFn("motorcycles/fad", token),
		...queryConfig
	});

	return {
		token: token,
		query: query,
		dehydratedState: dehydrate(queryClient)
	};
};


export default FADPage;